






import { Component, Vue } from "vue-property-decorator";
import BaseView from "@/components/Base/Elements/BaseView.vue";
import Organization from "@/components/Organization/Organization.vue";

@Component({
  extends: BaseView,
  components: {
    Organization
  }
})
export default class OrganizationView extends Vue {}
